<template>
  <div>
    <!-- <p class="c-inner-title">公众号管理</p> -->
    <div class="auto">
      <page-title title="公众号管理" icon="fa-windows"></page-title>
    </div>
    <div class="table-wrap m-t-15">
      <el-row class="table-toolbar margin-bottom-10">
        <el-col :span="12">
          <el-button @click="authJump" type="primary" size="small">新增用户</el-button>
        </el-col>
        <el-col :span="12" align="right">
          <el-select v-model="filter.customer_id" placeholder="选择客户" size="small">
            <el-option key="" label="全部" value=""></el-option>
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cn_name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-input placeholder="搜索公众号名称" suffix-icon="el-icon-search" style="margin-left: 5px;margin-right: 5px;width: 200px;" clearable v-model.trim="filter.nick_name" size="small"></el-input>
          <el-button type="primary" @click="handleChangeFilter" size="small">搜索</el-button>
        </el-col>
      </el-row>
      <div class="table-content" v-loading="loading">
        <el-table
        :data="body"
        style="width: 100%" size="small">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="nick_name"
            width="120"
            label="公众号名称">
          </el-table-column>
          <el-table-column
            prop="service_type_info"
            width="100"
            label="公众号类型">
          </el-table-column>
          <el-table-column
            prop="head_img"
            label="头像" width="100">
            <template slot-scope="scope">
              <img :src="scope.row.head_img" width="50" />
            </template>
          </el-table-column>
          <el-table-column
            prop="principal_name"
            label="主体">
          </el-table-column>
          <el-table-column
            prop="authorized"
            label="状态" width="50">
          </el-table-column>
          <el-table-column
            prop="customer_cn_name"
            width="80"
            label="客户">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="USERNAME">
          </el-table-column>
          <el-table-column
            prop="expire_time"
            label="access_token 过期时间">
            <template slot-scope="scope">
              {{util.timeStampFormat(scope.row.expire_time * 1000, 'yyyy-MM-dd h:m:s')}}
            </template>
          </el-table-column>
          <el-table-column
            prop="user_info_status"
            width="80"
            label="初始化状态">
          </el-table-column>
          <el-table-column
            prop="create_time"
            width="160"
            label="授权时间">
          </el-table-column>
          <el-table-column label="操作" width="400">
            <template slot-scope="scope">
              <el-button
                @click="handle(scope.row)"
                type="primary"
                size="small">
                权限管理
              </el-button>
              <el-button
                @click="handleSecretShow(scope.row)"
                type="primary"
                size="small">
                Secret管理
              </el-button>
              <el-button
                @click="handleCustomer(scope.row)"
                type="primary"
                size="small">
                客户管理
              </el-button>
              <el-button
                @click="handleRefresh(scope.row)"
                type="primary"
                size="small">
                更新信息
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="Number(filter.page)"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="Number(filter.limit)"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="权限管理" :visible.sync="moduleShow">
      <el-table :data="moduleList">
        <el-table-column
          label="模块"
          prop="name"
          width="120">
        </el-table-column>
        <el-table-column
          label="列表">
          <template slot-scope="scope">
            <el-checkbox-group v-if="moduleIds[scope.row.key]" v-model="moduleIds[scope.row.key]">
              <el-checkbox :label="item.key" :name="item.key" v-for="(item, index) in scope.row.module" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moduleShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateModuleSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="客户管理" :visible.sync="customerDiaglogVisible">
      <el-form label-width="80px" size="small">
        <el-form-item prop="status" label="选择客户">
          <el-select v-model="customerId" placeholder="选择客户" size="small">
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cn_name"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerDiaglogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateCustomerSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="Secret管理" :visible.sync="secretShow" width="800px">
      <div class="secret-btnbox">
        <el-button
          @click="secretAdd"
          type="primary"
          icon="el-icon-plus"
          size="small">
          添加
        </el-button>
      </div>
      <el-table :data="secretList" v-loading="secretLoading">
        <el-table-column
          label="secret"
          prop="secret"
          width="250">
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark">
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status">
          <template slot-scope="scope">
            {{scope.row.status > 0 ? '开启' : '关闭'}}
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time"
          width="150">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button
              @click="updateSecret(scope.row)"
              v-if="scope.row.status > 0"
              size="small">
              关闭
            </el-button>
            <el-button
              @click="updateSecret(scope.row)"
              type="primary"
              v-else
              size="small">
              开启
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="添加Secret" :visible.sync="secretAddShow">
      <el-form :model="secretForm" :rules="secretRules" ref="secretFormRef" label-width="80px" size="small">
        <el-form-item prop="remark" label="备注">
          <el-input type="textarea" v-model="secretForm.remark"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="secretForm.status" placeholder="请选择状态" size="small">
            <el-option
              v-for="item in secretStatusOption"
              :key="item.value"
              :label="item.name"
              :value="String(item.value)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="secretAddShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="secretAddHandle" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {System} from '../../../model'
export default {
  data () {
    return {
      loading: false,
      body: [],
      moduleShow: false,
      moduleIds: {
        // 'data': [],
        // 'mp': [],
        // 'setting': [],
        // 'content_hub': [],
        // 'system': []
        // 'account': []
      },
      moduleList: [],
      id: '',
      customerDiaglogVisible: false,
      customerList: [],
      customerId: [],
      modules: [],
      moduleIdsclone: {},
      btnLoading: false,
      filter: {
        customer_id: '',
        nick_name: '',
        type: 'mp',
        page: '1',
        limit: '10'
      },
      total: 0,
      secretShow: false,
      secretList: [],
      secretLoading: false,
      secretAddShow: false,
      secretStatusOption: [],
      secretForm: {
        remark: '',
        status: ''
      },
      secretRules: {
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    }
  },
  methods: {
    async handleRefresh (row) {
      this.loading = true
      let res = await System.refreshMpUserInfo({
        id: row.id
      })
      if (res['err_code']) {
        this.$message.error(res['err_msg'])
      } else {
        this.$message.success('更新成功')
        this.queryToFilter()
      }
    },
    handleChangeFilter () {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        customer_id: '',
        nick_name: '',
        type: 'mp',
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/system/system/authorizer', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getAuthorizerList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    async handleSecret (row) {
      this.$confirm('确定要生成接口秘钥吗?', '提示').then(async () => {
        let result = await System.createSecret({'id': row['id']})
        if (result !== false && !result['err_code']) {
          this.getAuthorizerList()
        } else {
          this.$message.error(result['err_msg'])
        }
      })
    },
    handleCustomer (row) {
      this.id = row['id']
      this.customerId = row['customer_id']
      if (this.customerList.length > 0) {
        this.customerDiaglogVisible = true
      } else {
        this.getCustomerList()
      }
    },
    async updateModuleSubmit () {
      this.btnLoading = true
      let res = await System.doModuleSubmit({
        id: this.id,
        module: this.moduleIds
      })
      this.btnLoading = false
      if (res !== false && !res['err_code']) {
        this.moduleShow = false
        this.$message.success('操作成功!')
        this.getAuthorizerList()
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async handle (row) {
      // let moduleIds = Object.assign({}, this.moduleIdsclone)
      // if (this.moduleList.length > 0) {
      //   this.moduleShow = true
      // } else {
      let res = await System.getModuleList()
      if (res !== false && !res['err_code'] !== 0) {
        this.moduleIds = {}
        this.moduleList = [...res['data']]
        this.moduleList.map(item => {
          this.moduleIds[item['key']] = []
        })
        if (row['module']) {
          row['module'].map(item => {
            item['module'].map(_item => {
              this.moduleIds[item['key']].push(_item['key'])
            })
          })
        }
        this.moduleIds = JSON.parse(JSON.stringify(this.moduleIds))
        this.id = row['id']
        this.moduleShow = true
      } else {
        this.$message.error(res['err_msg'])
      }
      // }
    },
    async authJump () {
      let res = await System.getUrl({'auth_type': '1'})
      if (res !== false && res['err_code'] === 0) {
        window.location.href = res['data']['url']
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async getAuthorizerList () {
      this.loading = true
      let res = await System.getAuthorizerList(this.filter)
      if (res !== false && !res['err_code']) {
        let body = []
        res['data']['list'].map(item => {
          if (item['service_type_info']) {
            if (String(JSON.parse(item['service_type_info'])['id']) === '2') {
              item['service_type_info'] = '服务号'
            } else {
              item['service_type_info'] = '订阅号'
            }
          } else {
            item['service_type_info'] = '非微信'
          }
          item['authorized'] = String(item['authorized']) === '1' ? '授权' : '取消'
          item['user_info_status'] = String(item['user_info_status']) === '1' ? '已初始化' : '未初始化'
          body.push(item)
        })
        this.body = body
        this.total = res['data']['total']
      } else {
        this.$message.error(res['err_msg'])
      }
      this.loading = false
    },
    async getCustomerList () {
      let res = await System.getCustomerList()
      if (res['err_code']) {
        this.$message.error(res['err_msg'])
      } else {
        this.customerList = res['data']['list']
        this.customerDiaglogVisible = true
      }
    },
    async updateCustomerSubmit () {
      this.btnLoading = true
      let res = await System.doCustomerSubmit({
        id: this.id,
        customer_id: this.customerId
      })
      this.btnLoading = false
      if (res['err_code']) {
        this.$message.error(res['err_msg'])
      } else {
        this.customerDiaglogVisible = false
        this.$message.success('操作成功!')
        this.getAuthorizerList()
      }
    },
    async customer () {
      let res = await System.authorizerCustomer()
      if (res['err_code']) {
        this.$message.error(res['err_msg'])
      } else {
        this.customerList = [...res['data']]
      }
    },
    handleSecretShow (row) {
      this.secretShow = true
      this.getApiSecretList(row.id)
      this.authorizerId = row.id
    },
    async getApiSecretStatusList () {
      let res = await System.getApiSecretStatusList()
      let options = []
      for (let key in res['data']) {
        options.push({
          value: key,
          name: res['data'][key]
        })
      }
      this.secretStatusOption = options
    },
    async getApiSecretList (id) {
      this.secretLoading = true
      let res = await System.getApiSecretList({
        authorizer_id: id
      })
      this.secretList = res['data']
      this.secretLoading = false
    },
    updateSecret (row) {
      this.updateApiSecretStatus(row)
    },
    async updateApiSecretStatus (row) {
      let res = await System.updateApiSecretStatus({
        secret: row.secret,
        status: -row.status
      })
      if (!res['err_code']) {
        this.getApiSecretList(row.authorizer_id)
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    secretAdd () {
      this.secretAddShow = true
      this.secretForm = {
        remark: '',
        status: ''
      }
    },
    secretAddHandle () {
      this.$refs['secretFormRef'].validate((valid) => {
        if (valid) {
          this.saveApiSecret()
        } else {
          return false
        }
      })
    },
    async saveApiSecret () {
      let res = await System.saveApiSecret({
        authorizer_id: this.authorizerId,
        remark: this.secretForm.remark,
        status: this.secretForm.status
      })
      if (!res['err_code']) {
        this.$refs['secretFormRef'].resetFields()
        this.secretAddShow = false
        this.getApiSecretList(this.authorizerId)
      } else {
        this.$message.error(res['err_msg'])
      }
    }
  },
  created () {
    this.moduleIdsclone = Object.assign({}, this.moduleIds)
    this.queryToFilter()
    this.customer()
    this.getApiSecretStatusList()
  }
}
</script>
<style scoped>
.secret-btnbox {
  margin-top: -20px;
  padding-bottom: 10px;
}
</style>
